import React from "react"
import Layout from "@layouts/Layout"
import Header from "@components/Header"
import Ebook from "@components/Ebook"
import Testimonials from "@components/Testimonials"
import Youtube from "@components/Youtube"
import Featured from "@components/Featured"
import { Col, Container, Row } from "react-bootstrap"
import Text from "../utils/text"
import SEO from "../components/SEO"
import { graphql } from "gatsby"

const Home = ({
  data: {
    videos: { nodes },
  },
}) => {
  return (
    <Layout>
      <SEO title="Home" />
      <Header />
      <Ebook />
      {/* <Testimonials /> */}
      <Container className="py-5 py-md-7 text-center">
        <Text id="6mgwMRuq7B1FIyHX2wj02E" />
        <Row>
          {nodes.map((video, index) => (
            <Col md={6} lg={4} key={index} className="mt-4">
              <Youtube link={video.youtubeLink} key={index} />
            </Col>
          ))}
        </Row>
        {/* <Featured /> */}
      </Container>
    </Layout>
  )
}

export const query = graphql`
  {
    videos: allContentfulYoutubeVideo {
      nodes {
        youtubeLink
      }
    }
  }
`

export default Home
